import { PaginationOptions } from '@jgereg/paginated';
import { useCallback } from 'react';
import { usePagination } from '../../hooks';
import { useTableFilters } from '../../hooks/useTableFilters';
import { FilterSortPaginated } from '../accidents/hooks/useAccidentsFilter';
import { AccountingDocument } from '../accountingDocuments/type/accountingDocuments';

export interface AccountingDocumentsFiltersType {
  search: string;
}

export const useAccountingDocumentsFilter = (
  data: AccountingDocument[],
  {
    defaultPaginationState = { page: 1, pageSize: 10 }
  }: Partial<{
    defaultPaginationState: PaginationOptions;
  }> = {}
): Omit<FilterSortPaginated<AccountingDocument, any>, 'sort'> => {
  const {
    data: filteredData,
    filters,
    setFilter: setAccountingDocumentsFiltersType
  } = useTableFilters<AccountingDocument, AccountingDocumentsFiltersType>(
    data,
    [
      (item, { search }) => {
        const matchesSearch =
          search !== ''
            ? [
                item.name,
                item.documentCode,
                item.documentNumber,
                item.customer?.name,
                item.customer?.surname,
                item.customer?.companyName,
                item.customer.companyIdNum
              ].some((field) => field?.toLowerCase().includes(search.toLowerCase()))
            : true;

        return matchesSearch;
      }
    ],
    {
      defaultFilterState: {
        search: ''
      }
    }
  );

  const { items, pagination, resetPagination, setPage } = usePagination(filteredData, defaultPaginationState);

  const handleFilterChange = useCallback(
    (filters: AccountingDocumentsFiltersType) => {
      resetPagination();
      setAccountingDocumentsFiltersType(filters);
    },
    [resetPagination, setAccountingDocumentsFiltersType]
  );

  return {
    items,
    filters: {
      filters,
      setFilters: handleFilterChange
    },
    pagination: {
      ...pagination,
      setPage
    }
  };
};
